var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatCheck = function SvgChatCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.667 8.51 1.56 1.56a9.99 9.99 0 0 1 3.039-3.29l.067-.047M14 8a6 6 0 0 1-6.848 5.94c-.802-.113-1.204-.17-1.31-.178-.17-.013-.11-.01-.281-.01-.105.001-.225.01-.462.027l-1.442.103c-.571.04-.857.06-1.07-.04a.9.9 0 0 1-.429-.428c-.1-.214-.08-.5-.04-1.071l.103-1.436c.017-.241.026-.362.027-.468 0-.172.003-.11-.01-.282-.008-.105-.065-.507-.179-1.31A6 6 0 1 1 14 8Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatCheck);
export default ForwardRef;